<template>
  <div
    class="month-grid"
    :data-testid="`${testid}-custom-picker-month`"
  >
    <v-list class="month-list-items">
      <v-list-item
        v-for="(monthLabel, index) in monthLabels"
        :key="index + 1"
        class="month-list-item"
        :class="{
          selected: isMonthSelected(index),
          disabled: isDisabled(index + 1),
          current: isCurrentMonth(index + 1),
        }"
        :disabled="isDisabled(index + 1)"
        @click="!isDisabled(index + 1) && $emit('select', index + 1)"
      >
        {{ monthLabel }}
      </v-list-item>
    </v-list>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue'

type DisabledFn = (month: number) => boolean

export default defineComponent({
  name: 'MonthGrid',
  props: {
    selected: {
      type: Number,
      default: null,
    },
    locale: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Function as PropType<DisabledFn>,
      required: true,
    },
    viewYear: { type: Number, required: true },
    selectedYear: { type: Number, required: true },
    testid: {
      type: String,
      required: true,
    },
  },
  emits: ['select'],
  setup(props) {
    const monthLabels = computed(() =>
      Array.from({ length: 12 }, (_, i) =>
        new Date(2000, i).toLocaleString(props.locale, { month: 'short' })
      )
    )

    const isCurrentMonth = (month: number) => {
      const today = new Date();
      const currentMonth = today.getMonth() + 1;
      const currentYear = today.getFullYear();
      return month === currentMonth && props.viewYear === currentYear
    }

    const isMonthSelected = (month: number) => {
      return props.selectedYear === props.viewYear && props.selected === month
    }

    return { monthLabels, isCurrentMonth, isMonthSelected }
  },
})
</script>

<style scoped>
.month-grid {
  width: 350px;
  height: 290px;
}

.month-list-items {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.81rem;
  padding: 0;
  margin: 0 30px;
  list-style: none;
}

.month-list-item {
  font-size: 0.875rem;
  height: 36px !important;
  min-height: 36px !important;
  max-height: 36px !important;
  width: 92%;
  margin: 0 auto;
  cursor: pointer;
  text-align: center;
  padding: 0.75rem 0;
  transition: background 0.2s;
}

.month-list-item:hover {
  background-color: rgb(var(--v-theme-primary) / 0.1);
}

.month-list-item.selected {
  background-color: rgb(var(--v-theme-primary));
  color: white;
}

.month-list-item.disabled {
  cursor: not-allowed;
  color: rgba(var(--v-theme-on-surface), var(--v-disabled-opacity));
}

.month-list-item.current {
  border: 1px solid rgb(var(--v-theme-primary));
  box-sizing: border-box;
}
</style>
